module.exports = __webpack_public_path__ + "img/roadmap-bubble-1.dd56e019.svg";